<script lang="ts">
import { IPanelRowState } from './panel-row-state.interface';
import { Component, Vue, Prop} from "vue-facing-decorator"

@Component({
    name: 'PanelRow',
})
export default class PanelRow extends Vue {
    @Prop() 
    public state!: IPanelRowState;

    public getState() {
        return this.state ?? {};
    }
}
</script>

<template>
    <div v-bind:class="{
            '-centered': getState().isCentered,
            '-has-no-border': getState().hasNoBorder,
            '-has-no-padding': getState().hasNoPadding,
            '-padded-content': getState().hasPaddedContent,
        }"
        class="m-panel__row">
        <slot></slot>
    </div>
</template>
